module.exports = __webpack_public_path__ + "img/15.cdfcc7bb.png";